export default __webpack_public_path__ + "static/play-a318ba9a265a7afccfa8a1c548ea6212.png";